// Cargos al comercio, renglón por renglón (Mario, 27-oct): el cargo por uso (flat_fee) y cada concepto (charges[]) de
// una versión de condiciones. Lo usan «Rige hoy» y el detalle de cada versión del historial: un solo armado.
// Sin tipos complejos: test/condiciones-cargos.test.mjs lo carga sin typescript.

const BASES: any = { SALE: 'sobre el monto vendido', FINANCED: 'sobre el saldo a financiar', COLLECTED: 'sobre lo cobrado', SETTLED: 'descontado por liquidación' };

const monto = (c: any) => (c.type_calc === 'PERCENTAGE' ? `${c.value} %` : `USD ${c.value}`);
// Mario, 27-oct: la base se dice siempre («eso se selecciona»); un monto fijo no depende de ella y se dice así.
// CND-07 (Mario, 2-nov, LQD-11: «que debe tomar lo configurado»): también en un contrato SETTLED el cargo en % va sobre su base
// configurada, una vez por compra. Antes (28-oct R9): «sobre lo liquidado».
const base = (c: any) => (c.type_calc === 'PERCENTAGE' ? BASES[c.base || 'SALE'] || '' : 'monto fijo por venta');
const cuando = (c: any) => (c.charged_with === 'INITIAL' ? 'con la inicial' : 'al liquidarle');

/**
 * Los cargos de una versión: primero el cargo por uso, luego cada concepto en su orden. Vacía si no hay ninguno
 * (nunca un renglón en cero). `cargoEnPausa` es el interruptor del comercio y solo apaga el cargo por uso que se
 * cobra con la inicial, el único que la caja le cobra al cliente.
 */
export const cargosDeComercio = (v: any, cargoEnPausa?: boolean) => {
  const filas: any[] = [];
  const f = v && v.flat_fee;
  if (f && f.value) {
    const pausado = !!cargoEnPausa && f.charged_with === 'INITIAL';
    filas.push({ clave: 'flat_fee', concepto: 'Cargo por uso', descripcion: '', monto: monto(f), base: base(f),
      cuando: cuando(f), estado: pausado ? 'Pausado' : 'Activo', pausado });
  }
  const cs: any[] = (v && v.charges) || [];
  cs.filter((c: any) => c && c.concept).forEach((c: any, i: number) => {
    const pausado = c.status === false;
    filas.push({ clave: `charge-${i}`, concepto: c.concept, descripcion: c.description || '', monto: monto(c), base: base(c),
      cuando: cuando(c), estado: pausado ? 'Pausado' : 'Activo', pausado });
  });
  return filas;
};
